<div
  id="snackbar"
  #snackbar
  class="hmf-px-m hmf-py-s hmf-elevated-shadow hmf-display-flex hmf-justify-content-between hmf-align-items-center"
  [class.show]="snackbarInfo().showSnackbar"
  [class.top-80]="hasBannerElement"
  (mouseenter)="clearTimer()"
  (mouseleave)="startTimer()">
  <p class="hmf-m-0 hmf-body-bold-m hmf-header-bold-m-s">
    @if (!snackbarInfo().isAuthSnackbar) {
      <span>{{ snackbarInfo().text }}</span>
    } @else {
      Please <span authUtilsAuthLink [redirectBackToUri]="true" class="authLink" analyticsEventToFireOnClick="multiUseAnalyticsEvent" [analyticsEventDataToFireOnClick]="analyticsEventData">
      </span> to Add to Favorites.
    }
</p>
@if (snackbarInfo().link) {
  <a [href]="snackbarInfo().link">View</a>
} @else {
  <homefield-icon class="icon" name="sign-cancel-outline" (click)="exitSnackbar()" (keydown.enter)="exitSnackbar()" (keydown.space)="exitSnackbar()"></homefield-icon>
}
</div>
